export const APP_VERSION = 'admin-2026.09.01.211627';
export const APP_NAME = 'admin';
